import React from 'react'
import { connect } from 'react-redux'
import { backToForm, sendForm, setLang } from 'state/actions'
import { reduxForm, change, SubmissionError } from 'redux-form'
import moment from 'moment'
import BpostSelect from '../bpostSelect'
import { DatePicker } from 'components/shared/datePicker'
import styles from './registration.scss'
import PhoneCountryCodesSelect from '../phoneCountryCodesSelect'
import Select from '../shared/select/SelectWrap'
import i18n from 'lib/i18n'

const cE = React.createElement
const N = {}

const wanted = ['clientNumber', 'firstName', 'name', 'street', 'isBelgium', 'number', 'dateOfBirth', 'placeOfBirth', 'email', 'emailAgain', 'phone_code', 'phoneNumber', 'policy']
const wantedBelgium = ['zipCity']
const wantedNotBelgium = ['country', 'city', 'zip',]
const ifCompany = ['companyName', 'companyRegistrationNumber']
const allFields = ['isCompany', 'optOut', 'lang', 'bus'].concat(wanted, ifCompany, wantedBelgium, wantedNotBelgium)

const _ = i18n('register')

const placeholder = { dateOfBirth: "DD-MM-JJJJ" }

require('resources/easinsure/easinsure-logotype-slogan.svg')
// this is required for low level IE
require('resources/easinsure/easinsure-logotype-slogan.jpg')

const Field = ({ field, field: { name }, type, options, surroundOptions }) => {
    const extraClassName = (surroundOptions && ( (surroundOptions.className && "field-" + name + "-" + surroundOptions.className) || "field-" + name) ) || "field-" + name
    return (
        <label className = { styles[extraClassName]  } >
        { (surroundOptions && surroundOptions.label) || _(name) }
        {
            (function() {
                switch (type) {
                    case 'date':
                        return <DatePicker {...field} placeholder="" className={styles.dateOfBirth}/>
                    case 'select':
                        return <Select {...field} options={options}/>
                    case 'BpostSelect':
                        return <BpostSelect {...field } />
                    case 'PhoneCountryCodesSelect':
                        return <PhoneCountryCodesSelect {...field} />
                    default:
                        return ( <input type = "text" placeholder = { placeholder[field] } {...field } /> )
                }
            })()
        } { field.error && field.touched && < div className = { styles.error } > { field.error } </div> }
        </label>
    )
}

const langOpt = [
        { value: 'nl', label: 'NL' },
        { value: 'fr', label: 'FR' },
    ]

const Registration = ({ fields, handleSubmit, setLang, onChangeIsBelgiumHandler }) => {
    const makeField = (fieldName, type, options, surroundOptions) => cE(Field, {
        key: fieldName,
        field: fields[fieldName],
        type,
        options,
        surroundOptions,
    })
    var isNotBelgiumSelected = Number(fields.isBelgium.value) > 0 ? false : true

    const isBelgOpt =  [
            { value: "0", label: _('yes') },
            { value: "1", label: _('no') },
        ]

    return (
        cE('div', { className: styles.form },
            cE('div', { className: styles.top },
                cE('img', {
                    id: styles.logo,
                    src: require('resources/easinsure/easinsure-logotype-slogan.svg'),
                }),
                cE('div', { className: styles.langInput },
                    <label>
                        <Select 
                            className={styles.language}
                            options={langOpt} 
                            {...fields.lang}
                            onChange={ev => {setLang(ev.value)}}
                            value={global.lang}
                        />
                    </label>
                )
            ),
            cE('div', {
                    className: styles.inputDiv,
                },
                makeField('isCompany', 'select', [{
                    value: "",
                    label: _('personOpt'),
                }, {
                    value: "1",
                    label: _('companyOpt'),
                }, ]),
                makeField('clientNumber'),
                Number(fields.isCompany.value) ? [
                    makeField('companyName'),
                    makeField('companyRegistrationNumber'),
                ] : [],
                [
                    makeField('firstName'),
                    makeField('name'),
                    cE('div', {key: 'isBelgium'},
                        <label className = { styles["field-isBelgium"] } >
                            {_("isBelgium")}
                            <Select
                                options={isBelgOpt}
                                {...fields.isBelgium}
                                onChange={e => onChangeIsBelgiumHandler(e)}
                                value={fields.isBelgium.value}
                            />
                        </label>
                    ),
                    !isNotBelgiumSelected ? [ makeField('country', 'text', {}, {label: _('countryName')})] : [],
                    makeField('street'),
                    makeField('number'),
                    makeField('bus', 'text', {}, {label:  _("registration_bus")} ),
                    isNotBelgiumSelected ? [
                            makeField('zipCity', 'BpostSelect'),
                        ] : [
                            makeField('zip', 'text', {}, {label: _('zip'), className: (!isNotBelgiumSelected ? "noBelgian" : "" ) }),
                            makeField('city', 'text', {}, {label: _('city'), className: (!isNotBelgiumSelected ? "noBelgian" : "" ) }),
                        ],
                    cE('br', {key: 'br0'}),
                    makeField('dateOfBirth', 'date'),
                    makeField('placeOfBirth'),
                    makeField('email'),
                    makeField('emailAgain', 'text', {},
                        {
                            label:  _("repeat_email"),
                        }
                    ),
                    makeField('phone_code', 'PhoneCountryCodesSelect'),
                    makeField('phoneNumber', 'text', {}, { label: _('phoneNumber')})
                ]
            ),  <p>
                    <span key = { 0 } > { _('privacyPart1') } </span>&nbsp;
                    <a target = "_new" href = { _('privacyLinks') } ><span key = { 0 } >{ _('privacyPart2')}</span> </a>.
                </p>,
                <p>
                    <span key = { 0 } > { _('privacyPart5') } </span>
                    <a target = "_new" href = { _('privacyLinks2') }>
                        <span key = { 0 } >{_('privacyPart2')}</span>
                    </a> &nbsp;
                    <input type = "checkbox" {...fields.policy}/>
                    { fields.policy.error && fields.policy.touched && < div className = { styles.error } > { fields.policy.error } </div> }
                </p>,
                <p>
                    <span key = { 0 } > { _('privacyPart3') } </span>
                </p>,
                <p>
                    <span key = { 0 } > { _('privacyPart4') } </span> &nbsp; <input type = "checkbox" {...fields.optOut}/>
                </p>,
            cE('button', {
                type: 'button',
                className: styles.button,
                style: {
                    marginTop: "2em",
                },
                onClick: handleSubmit,
            }, _('register')),
            cE('button', {
                    type: 'button',
                    className: styles.backButton,
                    style: {
                        marginTop: "10px",
                    },
                    onClick() {
                        return window.location.reload()
                    },
                },
                _('back'))
        )
    )
}

const ConnReg = reduxForm({
    form: 'registration',
    destroyOnUnmount: false,
    fields: allFields,
    validate(data) {
        let errors
        errors = {}
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
            errors.email = _('invalidEmail')
        }
        if (data.email !== data.emailAgain) {
            errors.emailAgain = _('email_not_match')
        }
        if (!moment(data.dateOfBirth).isValid()) {
            errors.dateOfBirth = _('invalidDate')
        }

        if( wanted.includes("isBelgium") ) {
            data.isBelgium = (data.isBelgium === undefined ? "0" : data.isBelgium)
        }

        let extraRequireArray = wantedBelgium
        if (Number(data.isBelgium) === 1) {
            extraRequireArray = wantedNotBelgium
        }

        for (const fieldName of extraRequireArray) {
            if (!data[fieldName]) {
                errors[fieldName] = _('required')
            }
        }

        for (const fieldName of wanted) {
            if (!data[fieldName]) {
                errors[fieldName] = _('required')
            }
        }
        if (data.isCompany) {
            for (const fieldName of ifCompany) {
                if (!data[fieldName]) {
                    errors[fieldName] = _('required')
                }
            }
        }
        return errors
    },
})(Registration)

@connect((state) => ({
    reg: state.registration,
    lang: state.app.lang,
}))
class Stuff extends React.Component {
    static propTypes = {
        reg: React.PropTypes.object,
        dispatch: React.PropTypes.func,
        lang: React.PropTypes.string,
    }

    render() {
        const { reg, lang, dispatch } = this.props
        return cE('div', {},
            reg.isSending ? (
                _('to_send')
            ) : (
                reg.sent ? (
                    cE('div', {className: styles.registrationConfirmationContainer},
                        cE('p', N, _('request_has_been_sent')),
                        cE('p', N, _('you_will_receive_your_login'))
                    )
                ) : (
                    reg.problem ? (
                        cE('div', N,
                            _('a_problem_has_occured') +
                            reg.problem,
                            cE('button', {
                                    onClick: () => this.props.dispatch(backToForm()),
                                },
                                _('try_again')
                            ),
                        )
                    ) : (
                        cE(ConnReg, {
                            initialValues: {
                                lang,
                                isBelgium: "0",
                                phone_code: "0032"
                            },
                            setLang: (lang) => {
                                this.props.dispatch(setLang(lang))
                            },
                            onChangeIsBelgiumHandler: e => {
                                if(e.value == 0){
                                    this.props.dispatch(change("registration", "phone_code", "0032"))
                                }else{
                                    this.props.dispatch(change("registration", "phone_code", ""))
                                }
                                this.props.dispatch(change("registration", "isBelgium", e.value))
                            },
                            onSubmit: (data) => {
                                const [postalCode, locality] =
                                    Number(data.isBelgium) !== 1 ? data.zipCity.split('_') : [data.zip, data.city]
                                data.lang = global.lang
                                let splitPhoneNumber = data.phoneNumber.split('')
                                if(splitPhoneNumber[0] === '0'){
                                    splitPhoneNumber[0] = data.phone_code
                                    data.phoneNumber = splitPhoneNumber.join('')
                                }else{
                                    data.phoneNumber = `${data.phone_code}${data.phoneNumber}`
                                }
                                delete data.phone_code
                                const allData = {
                                    ...data,
                                    zipCity: undefined,
                                    postalCode,
                                    locality,
                                }
                                this.props.dispatch(sendForm(allData))
                            },
                        })
                    )
                )
            )
        )
    }
}

export default Stuff



// WEBPACK FOOTER //
// ./components/auth/registration.jsx